// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.actionItemsByMonthTableWrapper__jk7jZ {
  padding: 15px;
}
@media (max-width: 860px) {
  .actionItemsByMonthTableWrapper__jk7jZ {
    padding: 10px;
  }
}

.actionItemsByMonthTable__ZutuA {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border-bottom: 1px solid var(--tables-title-stroke);
  position: relative;
  box-shadow: 0px 3px 8px -1px rgba(50, 50, 71, 0.0509803922), 0px 0px 1px 0px rgba(12, 26, 75, 0.2392156863);
}
.actionItemsByMonthTable__ZutuA thead {
  position: sticky;
  z-index: 1;
  top: 45px;
}
@media (max-width: 1285px) {
  .actionItemsByMonthTable__ZutuA thead {
    top: 65px;
  }
}
.actionItemsByMonthTable__ZutuA th {
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--tables-title-text);
  padding: 16px 25px;
  background: var(--tables-title-surface);
  text-align: left;
  text-wrap: nowrap;
}
@media (max-width: 1080px) {
  .actionItemsByMonthTable__ZutuA th {
    padding: 16px 15px;
    font-size: 9px;
  }
}
@media (max-width: 920px) {
  .actionItemsByMonthTable__ZutuA th {
    padding: 16px 10px;
  }
}
.actionItemsByMonthTable__ZutuA td {
  padding: 10px 25px;
  color: var(--tables-primary-row-text-main);
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  background: var(--tables-primary-row-surface-default);
  white-space: normal;
  font-size: 14px;
  line-height: 16px;
}
@media (max-width: 1080px) {
  .actionItemsByMonthTable__ZutuA td {
    padding: 10px 15px;
    font-size: 12px;
  }
}
@media (max-width: 920px) {
  .actionItemsByMonthTable__ZutuA td {
    padding: 10px 10px;
  }
}

.equipmentStatusColumn__p6GF9 {
  max-width: 40px;
}

.bodyRow__jtA6u:hover td {
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  background: var(--tables-primary-row-surface-hover);
}

.sortIcon__nm2bv {
  margin-left: 5px;
  cursor: pointer;
  outline: none;
  min-width: 6px;
}
.sortIcon__nm2bv path {
  fill: var(--tables-title-icon);
}

.activeSort__z8PtD path {
  fill: var(--tables-primary-row-icon);
}

.facilityName__b6aFo {
  color: var(--tables-primary-row-text-additional);
  font-size: 12px;
}

.equipmentNameColumn__ZyUdC {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-clamp: 3;
}

.iconColumn__G2TNC {
  text-align: right;
  cursor: pointer;
}
.iconColumn__G2TNC path {
  stroke: var(--buttons-surface);
}

.viewDetailsIcon__nBKFA {
  outline: none;
  vertical-align: baseline;
}

.skeletonText__qRhq2 {
  height: 16px;
  vertical-align: bottom;
  z-index: 0;
}

.skeletonIcon__BmNBV {
  width: 16px;
  height: 16px;
  vertical-align: bottom;
  z-index: 0;
}`, "",{"version":3,"sources":["webpack://./../src/pages/CostSavingsDetails/components/ActionItemsByMonthTable/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;AAzEF;AA2EE;EAHF;IAII,aAAA;EAxEF;AACF;;AA2EA;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,mDAAA;EAEA,kBAAA;EACA,2GACE;AA1EJ;AA6EE;EACE,gBAAA;EACA,UAAA;EACA,SAAA;AA3EJ;AA6EI;EALF;IAMI,SAAA;EA1EJ;AACF;AA6EE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,+BAAA;EACA,kBAAA;EACA,uCAAA;EACA,gBAAA;EACA,iBAAA;AA3EJ;AA6EI;EAZF;IAaI,kBAAA;IACA,cAAA;EA1EJ;AACF;AA4EI;EAjBF;IAkBI,kBAAA;EAzEJ;AACF;AA4EE;EACE,kBAAA;EACA,0CAAA;EACA,yDAAA;EACA,qDAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AA1EJ;AA4EI;EATF;IAUI,kBAAA;IACA,eAAA;EAzEJ;AACF;AA2EI;EAdF;IAeI,kBAAA;EAxEJ;AACF;;AA2EA;EACE,eAAA;AAxEF;;AA4EE;EACE,yDAAA;EACA,mDAAA;AAzEJ;;AA6EA;EACE,gBAAA;EACA,eAAA;EACA,aAAA;EACA,cAAA;AA1EF;AA4EE;EACE,8BAAA;AA1EJ;;AA+EE;EACE,oCAAA;AA5EJ;;AAgFA;EACE,gDAAA;EACA,eAAA;AA7EF;;AAgFA;EAhIE,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;EACA,oBAAA;EACA,4BAAA;EA6HA,qBAAA;EACA,aAAA;AAxEF;;AA2EA;EACE,iBAAA;EACA,eAAA;AAxEF;AA0EE;EACE,8BAAA;AAxEJ;;AA4EA;EACE,aAAA;EACA,wBAAA;AAzEF;;AA4EA;EACE,YAAA;EACA,sBAAA;EACA,UAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,UAAA;AAzEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.actionItemsByMonthTableWrapper {\n  padding: 15px;\n\n  @media (max-width: 860px) {\n    padding: 10px;\n  }\n}\n\n.actionItemsByMonthTable {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  border-bottom: 1px solid var(--tables-title-stroke);\n\n  position: relative;\n  box-shadow:\n    0px 3px 8px -1px #3232470d,\n    0px 0px 1px 0px #0c1a4b3d;\n\n  thead {\n    position: sticky;\n    z-index: 1;\n    top: 45px;\n\n    @media (max-width: 1285px) {\n      top: 65px;\n    }\n  }\n\n  th {\n    font-size: 10px;\n    font-weight: 400;\n    line-height: 12px;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n    color: var(--tables-title-text);\n    padding: 16px 25px;\n    background: var(--tables-title-surface);\n    text-align: left;\n    text-wrap: nowrap;\n\n    @media (max-width: 1080px) {\n      padding: 16px 15px;\n      font-size: 9px;\n    }\n\n    @media (max-width: 920px) {\n      padding: 16px 10px;\n    }\n  }\n\n  td {\n    padding: 10px 25px;\n    color: var(--tables-primary-row-text-main);\n    border-bottom: 1px solid var(--tables-primary-row-stroke);\n    background: var(--tables-primary-row-surface-default);\n    white-space: normal;\n    font-size: 14px;\n    line-height: 16px;\n\n    @media (max-width: 1080px) {\n      padding: 10px 15px;\n      font-size: 12px;\n    }\n\n    @media (max-width: 920px) {\n      padding: 10px 10px;\n    }\n  }\n}\n.equipmentStatusColumn {\n  max-width: 40px;\n}\n\n.bodyRow {\n  &:hover td {\n    border-bottom: 1px solid var(--tables-primary-row-stroke);\n    background: var(--tables-primary-row-surface-hover);\n  }\n}\n\n.sortIcon {\n  margin-left: 5px;\n  cursor: pointer;\n  outline: none;\n  min-width: 6px;\n\n  path {\n    fill: var(--tables-title-icon);\n  }\n}\n\n.activeSort {\n  path {\n    fill: var(--tables-primary-row-icon);\n  }\n}\n\n.facilityName {\n  color: var(--tables-primary-row-text-additional);\n  font-size: 12px;\n}\n\n.equipmentNameColumn {\n  @include ellipsis-text;\n  -webkit-line-clamp: 3;\n  line-clamp: 3;\n}\n\n.iconColumn {\n  text-align: right;\n  cursor: pointer;\n\n  path {\n    stroke: var(--buttons-surface);\n  }\n}\n\n.viewDetailsIcon {\n  outline: none;\n  vertical-align: baseline;\n}\n\n.skeletonText {\n  height: 16px;\n  vertical-align: bottom;\n  z-index: 0;\n}\n\n.skeletonIcon {\n  width: 16px;\n  height: 16px;\n  vertical-align: bottom;\n  z-index: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"actionItemsByMonthTableWrapper": `actionItemsByMonthTableWrapper__jk7jZ`,
	"actionItemsByMonthTable": `actionItemsByMonthTable__ZutuA`,
	"equipmentStatusColumn": `equipmentStatusColumn__p6GF9`,
	"bodyRow": `bodyRow__jtA6u`,
	"sortIcon": `sortIcon__nm2bv`,
	"activeSort": `activeSort__z8PtD`,
	"facilityName": `facilityName__b6aFo`,
	"equipmentNameColumn": `equipmentNameColumn__ZyUdC`,
	"iconColumn": `iconColumn__G2TNC`,
	"viewDetailsIcon": `viewDetailsIcon__nBKFA`,
	"skeletonText": `skeletonText__qRhq2`,
	"skeletonIcon": `skeletonIcon__BmNBV`
};
module.exports = ___CSS_LOADER_EXPORT___;
